import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-unit4-introduction',
  templateUrl: './unit4-introduction.component.html',
  styleUrls: ['./unit4-introduction.component.css']
})
export class Unit4IntroductionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
